import { Component, Input, OnInit } from '@angular/core';
import { PaymentProfile } from 'src/app/core/interfaces/purchase.model';
import { Account } from 'src/app/core/interfaces/user.model';

@Component({
  selector: 'app-payment-card',
  templateUrl: './payment-card.component.html',
  styleUrls: ['./payment-card.component.css'],
})
export class PaymentCardComponent implements OnInit {
  @Input() tarjeta: PaymentProfile;
  @Input() cuenta: Account;

  constructor() {}

  ngOnInit(): void {}
}
